export class WrappedError extends Error {
    public readonly cause: any;

    constructor(message: string, cause: any) {
        super(message);
        this.name = 'WrappedError';
        if (cause && cause.stack) {
            this.stack = `${this.stack}\n${cause.stack}`;
        }
        this.cause = cause;
    }
}
